import {createFileRoute} from '@tanstack/react-router';
import ClubTeamsPage from '../../../../players/ClubTeamsPage.tsx';

export const Route = createFileRoute('/_app/roundnet/teams/')({
    component: () => <ClubTeamsPage sport="roundnet" />,
});
